import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { ModalLayout } from '@appbase/templates'
import BoardRead from '@board/components/board/BoardRead.vue'

@Component({
    components: {
        ModalLayout,
        BoardRead,
    },
})
export default class BoardModal extends Vue {
    @Prop({ type: Number, required: true }) boardId!: number
    @Prop({ type: Number, required: true }) articleId!: number
    @Prop({ type: String, required: true }) title!: string
    @Prop({ type: String }) lookahead?: string

    // 팀즈 모달에서도 웹 팝업과 동일하게 하단 영역(댓글/추천/버튼)을 노출하고
    // 수정/답글은 모달 내에서 BoardWrite 로 전환하여 처리 (BoardMain 미리보기와 동일한 방식)
    writeComponent: any = null
    writeParams: board.PreviewSet | null = null

    get readParams() {
        const { boardId, articleId, title, lookahead } = this
        return {
            boardId, articleId, title, lookahead,
            showButtons: true
        }
    }

    showWrite(articleId: number | null, parentArticleId: number | null) {
        // BoardWrite 가 BoardModal 을 import 하므로 순환참조 방지를 위해 런타임에 로드
        this.writeComponent = require('@board/components/board/BoardWrite.vue').default
        this.writeParams = {
            boardId: this.boardId,
            articleId: articleId,
            parentArticleId: parentArticleId,
            showHeader: false,
            showButtons: true
        }
    }

    onEdit(article: article.ArticleDetail) {
        this.showWrite(article.articleId, article.parentArticle)
    }

    onReply(article: article.ArticleDetail) {
        this.showWrite(null, article.articleId)
    }

    // 수정/답글 저장 또는 취소 시 게시글 읽기 화면으로 복귀
    onWriteClose() {
        this.writeComponent = null
        this.writeParams = null
    }

    handleClose() {
        this.closeCurrentModal()
    }
}
